import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'PassengerFlowService',
    controller: 'PassengerFlow'
};

const methods = [
    'GetPassengerFlowList',
    'GetChartDataEachHour'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const PassengerFlowApi = ZJApi.defineNewApi('PassengerFlowApi', factory);
export default PassengerFlowApi;